import React from 'react';
import { AwardIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, included, price, priceBefore, productName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-mist contour-light py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-160" data-mp="1j8p1xdh65dik">
      <div className="mx-auto max-w-3xl px-4" data-id="element-161" data-mp="1nbbw3l1bbaix">
        <h2 id="pricing-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-162" data-mp="1ncmz3imxoe8z">
          Elegí tu pack
        </h2>

        <article className="mt-10 overflow-hidden rounded-2xl border-2 border-yellow bg-white shadow-lift" data-id="element-163" data-mp="1x86w68d8hizb">
          <div className="tick-bar h-3 w-full" aria-hidden="true" data-id="element-164" data-mp="22830y9tr9efx" />
          <div className="p-6 sm:p-10" data-id="element-165" data-mp="2up4qa9pk1z0">
            <span className="inline-flex items-center gap-2 rounded-md bg-navy px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.16em] text-yellow" data-id="element-166" data-mp="2vqqp9s9i8vi">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-167" data-mp="1mgoelaxrp9kc" /> Oferta principal
            </span>

            <div className="mt-5 flex flex-col gap-6 border-b border-line pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-168" data-mp="1hq7zlmeatfvv">
              <div data-id="element-169" data-mp="1crwqxezqpbf8">
                <h3 className="font-display text-2xl font-extrabold uppercase leading-tight text-ink" data-id="element-170" data-mp="1crekxqn9ziu4">{productName}</h3>
                <p className="mt-2 text-sm text-muted" data-id="element-171" data-mp="17ppaac3yt76k">
                  Los {totalVolumes} tomos + {totalBonuses} bonos estratégicos listos para usar en el aula.
                </p>
              </div>
              <div className="sm:text-right" data-id="element-172" data-mp="20ed2krn4swtm">
                <span className="text-sm text-muted" data-id="element-173" data-mp="1vgl7xpv3qwlq">
                  Precio regular <span className="line-through" data-id="element-174" data-mp="1rfrkexlknjtd">{priceBefore}</span>
                </span>
                <p className="mt-1 font-display text-5xl font-extrabold text-navy" data-id="element-175" data-mp="1ri42rbv8rw6y">{price}</p>
                <p className="text-xs font-extrabold uppercase tracking-[.16em] text-green" data-id="element-176" data-mp="jzuylxvdtonw">Hoy · 50% de descuento</p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-177" data-mp="hj2xezjcg9fb">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-ink" data-id="element-178" data-mp="mh4ghkgrs8qs">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-green" aria-hidden="true" data-id="element-179" data-mp="7kdcexw5i8uu" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-180" data-mp="ckhx7043dpqv">
              Quiero el Mega Pack — {price}
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-181" data-mp="3jbcsfybnusc">
              <span className="inline-flex items-center gap-1.5" data-id="element-182" data-mp="3kwnh26xolyoz">
                <LockIcon className="h-4 w-4 text-navy" aria-hidden="true" data-id="element-183" data-mp="3py33o3ficd9h" /> Pago seguro
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-184" data-mp="3bylma94jk2a5">
                <ZapIcon className="h-4 w-4 text-navy" aria-hidden="true" data-id="element-185" data-mp="3fznei601je2m" /> Acceso inmediato
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-186" data-mp="2xbwbhb4ua2og">
                <ShieldCheckIcon className="h-4 w-4 text-green" aria-hidden="true" data-id="element-187" data-mp="2scjqkvxj35oi" /> Garantía 7 días
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-muted" data-id="element-188" data-mp="36ckukk93at87">
              Pagás en USD. Tu plataforma de pago muestra la conversión a tu moneda local automáticamente.
            </p>
          </div>
        </article>
      </div>
    </section>;
}